import React from 'react';

const Close = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
    <path
      fillRule="evenodd"
      d="M13.292 2.118a.997.997 0 0 0 .003-1.413.999.999 0 0 0-1.413.003L7 5.59 2.118.708A.997.997 0 0 0 .705.705a.999.999 0 0 0 .003 1.413L5.59 7 .708 11.882a.997.997 0 0 0-.003 1.413.999.999 0 0 0 1.413-.003L7 8.41l4.882 4.882a.997.997 0 0 0 1.413.003.999.999 0 0 0-.003-1.413L8.41 7l4.882-4.882z"
    />
  </svg>
);

export default Close;
